<template>
  <div id="scrollTop" :class="{ 'one-column': $mq === 'sm' }" v-if="visible" @click.prevent="scrollTop()">
    <topArrow />
  </div>
</template>
<style lang="scss">
#scrollTop {
  position: fixed;
  z-index: 1000;
  bottom: 25px;
  right: 20px;
  cursor: pointer;

  &:hover {
    .top-arrow-path {
      fill: #bbbbbb;
    }
  }

  &.one-column {
    bottom: auto;
    top: 7px;
    left: 50%;
    right: 50%;

    .top-arrow-path {
      fill: #eee;
    }
  }
}
</style>
<script>
import topArrow from '@/components/icons/top-arrow'

export default {
  components: { topArrow },
  data: () => ({
    timeoutId: null,
    visible: false,
    mainContent: null
  }),
  methods: {
    scrollTop() {
      if (this.mainContent) {
        this.mainContent.scrollTop = 0
      }
    },
    onScroll(event) {
      if (!this.timeoutId) {
        this.timeoutId = setTimeout(() => {
          this.visible = event.target.scrollTop > 100
          this.timeoutId = null
        }, 150)
      }
    },
    attachListener() {
      this.mainContent = document.querySelector('#mainContent')
      if (this.mainContent) {
        this.mainContent.removeEventListener('scroll', this.onScroll, { passive: true })
        this.mainContent.addEventListener('scroll', this.onScroll, { passive: true })
      }
    }
  },
  mounted() {
    this.$root.$on('contentmounted', this.attachListener)
  },
  beforeDestroy() {
    this.$root.$off('contentmounted', this.attachListener)
    if (this.mainContent) {
      this.mainContent.removeEventListener('scroll', this.onScroll, { passive: true })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/scroll-to-top.vue